import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { GalleryFetchService } from "./gallery-fetch.service";
import { AddDirComponent } from '../add-dir/add-dir.component';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { EditComponent } from './../edit/edit.component';

import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  // Telstra
  // s3 = new S3({
  //   accessKeyId: "AKIAZ3ROG2OF2OE46DOA",
  //   secretAccessKey: "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",
  //   signatureVersion: "v4",
  //   region: "ap-southeast-2",
  //   apiVersion: '2006-03-01'
  // });

  // PwC
  s3 = new S3({
    accessKeyId: "AKIA4OZCN3SEYR3ZRGFN",
    secretAccessKey: "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",
    signatureVersion: "v4",
    region: "ap-southeast-1",
    apiVersion: '2006-03-01'
  });

  @ViewChild("content") content;
  tower: string;
  role;
  dirLink = null;
  view: string;
  imageData = [];
  prevDir = 0;
  crntDir = 0;
  index = 0;
  sliderIndex = false;
  loading = false;
  result;
  data;
  imageDir = [];
  dirValue;
  isLoaded = false;
  constructor(private fireStore: AngularFirestore, private dialog: MatDialog, private route: ActivatedRoute, private service: GalleryFetchService, private renderer: Renderer2, private snackBar: MatSnackBar, private router: Router) {
    if (this.router.url.search("aero-processing") == 1) {
      this.role = "aero-processing";
    }
    if (this.router.url.search("user") == 1) {
      this.role = 'user';
    }
    if (this.router.url.search("pilot") == 1) {
      this.role = 'pilot';
    }
    if (this.router.url.search("super-admin") == 1) {
      this.role = 'super-admin';
    }
    if (this.router.url.search("telstra-processing") == 1) {
      this.role = 'telstra-processing';
    }

    this.route.params.subscribe(params => {
      this.tower = params.tower;
      this.getTower();
    })

  }

  getTower() {
    this.isLoaded = false;
    this.index = 0;
    this.service.fetchData(this.tower).subscribe(
      (result) => {
        let temp = {};
        temp = result.data();
        if (temp['Gallery'] != undefined) {
          this.imageData = temp['Gallery'];
        } else {
          this.imageData = [];
        }
      },
      (err) => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      () => {
        if (this.imageData.length > 0) {
          this.isLoaded = true;
        }
      })
  }


  ngOnInit(): void {
  }

  setCrntDir(event) {
    this.crntDir = event.crntDir;
    this.index = event.contentLoadedEvent;

  }
  sendIndex(event) {
    this.sliderIndex = event.sliderIndex;
    this.index = event.index;
  }



  addDir(event) {
    const dialogRef = this.dialog.open(AddDirComponent, {
      width: '500px',
      maxHeight: '480px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == null || result == undefined) { return; }
        this.dirLink = result;
      },
      err => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      async () => {
        let temp = this.imageData;
        let resNw = this.dirLink.split('/')
        // let dirName = this.dirLink ? this.dirLink.split('/')[3] : null;
        console.log('resNw - ',resNw);
        let dirName = resNw[resNw.length - 1];

        let tmpVar = dirName.replace(/\s/g,'')
        if(tmpVar==""){
          dirName = resNw[resNw.length - 2];
        }
        let firestore = this.fireStore.collection(this.tower).doc(this.tower);
        console.log('this.dirLink - ', this.dirLink);
        console.log('dirName - ',dirName);

        var bucketParams = {
          Bucket: "aerodyne-true-thailand",
          Prefix: this.dirLink
        };
        this.s3.listObjects(bucketParams, function (err, data) {
          if (err) {
            this.snackBar.open(err, "close", { duration: 2000 });
          }
          this.imageDir = data.Contents;
          console.log('data.Contents - ', data.Contents);

          let arr = []
          if (this.imageDir.length > 0) {
            for (var i = 0; i < this.imageDir.length; i++) {
              let tempNw = this.imageDir[i].Key.split(".");
              let key = tempNw[tempNw.length - 1];
              console.log('key - ', key);

              if(key == "jpg" || key == "jpeg" || key == "JPG" || key == "JPEG"){
                // https://aerodyne-pwc-telco.s3.amazonaws.com/towers_data/TWR.ASH.TRANQUILLE/CV/DJI_0541.JPG
                // arr.push({ file: "https://aerodyne-telstra-dev.s3-ap-southeast-2.amazonaws.com/" + this.imageDir[i].Key })
                // https://aerodyne-true-thailand.s3.ap-southeast-1.amazonaws.com/20210818_Field+practice/TOWER+ID+PTT1099(GRF)/9.1EGP/Tower+foundation+and+Overall+Connection/DSC00347.JPG
                arr.push({ file: "https://aerodyne-true-thailand.s3.ap-southeast-1.amazonaws.com/" + this.imageDir[i].Key })
              }
            }
            console.log(' arr - ', arr);
            this.imageData = temp;
            this.imageData.push({
              Directory: dirName,
              Payload: arr
            });

            if (arr.length > 0 && dirName != '') {
              firestore.update({
                Gallery: this.imageData
              }).catch(err => {
                this.snackBar.open(err, "close", { duration: 2000 });
              })
            }else{
              this.snackBar.open('ERROR!', "close", { duration: 2000 });
            }

          }
          this.dirLink = null;
        });

      }
    )
  }


  editDir(event) {
    console.log(event);
    const dialogRef = this.dialog.open(EditComponent, {
      width: '450px',
      maxHeight: '480px',
      data: { name: "Directory", value: event.value }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        this.dirValue = result.value;
      },
      err => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      () => {
        this.imageData[event.index].Directory = this.dirValue;
        this.updateData();
      })
  }

  updateData() {
    this.service.setData(this.tower).update({
      Gallery: this.imageData
    }).catch(err => {
      this.snackBar.open(err, "close", { duration: 2000 });
    })
  }

  deleteDir(event) {
    event.forEach(data => {
      this.imageData = this.imageData.filter(elt => {
        return (elt.Directory === data.name) ? false : true;
      });
      console.log(event)
      this.updateData();

    });
  }

}
